import React, { ReactNode } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { PreferenceName as PreferenceNameType } from '../types';
import { Gql } from '../../../types';
import { PreferenceName } from './PreferenceName';
import { MatchIndicator } from './MatchIndicator';

export const Preference = ({
  name,
  children,
  matchIndicator,
  tooltipContent,
}: {
  name: PreferenceNameType;
  children: ReactNode;
  matchIndicator?: Gql.Maybe<Gql.DmBriefMatchIndicator>;
  tooltipContent?: ReactNode;
}) => (
  <Stack gap="8" justifyContent="spaceBetween" alignItems={'center'}>
    <Stack minHeight="24px" alignItems="flexStart" width="100%" gap="8" direction={{ default: 'column', sm: 'row' }}>
      <Stack gap={{ default: '1', sm: '2' }} width="100%" direction={{ default: 'column', sm: 'row' }}>
        <PreferenceName name={name} />
        <Stack
          width="100%"
          wrap="wrap"
          flexShrink={1}
          direction={{ default: 'column', md: 'row' }}
          gap={{ default: '0', sm: '1' }}
        >
          {children}
        </Stack>
      </Stack>
      {matchIndicator && (
        <MatchIndicator
          matchIndicator={matchIndicator}
          display={{ default: 'none', sm: 'flex' }}
          tooltipContent={tooltipContent}
        />
      )}
    </Stack>
    {matchIndicator && (
      <MatchIndicator
        matchIndicator={matchIndicator}
        display={{ default: 'flex', sm: 'none' }}
        tooltipContent={tooltipContent}
      />
    )}
  </Stack>
);
